/* eslint-disable complexity */
'use client';
import React, { useEffect, useState } from 'react';

import { Box } from '@osmosis/react-ui/components/Box';
import { useColors } from '@osmosis/react-ui/hooks/useColors';
import RichText from '../block-ui/RichText';
import PlansSelection from '../../../components/plans/PlansSelection';
import { Headers } from '../../../components/composer/blocks/TextBanner';
import { ComposerBlock, ComposerPlansElement } from '../../../types/composer';
import AdminWrapper from '../../../components/composer/AdminWrapper';
import { mockPlansPage } from '../../../constants/plans';

import { useFetch } from '../../../context/FetchProvider';
import { Plan } from '../../../types/plans';
import { getPlans, trackPlansView } from '../../plans/utils';
import { sharedPlanSelectorFields } from './PlanSelectorSchema';

/**
 * Text banner block.
 */
const PlanSelector: ComposerPlansElement = (props: any) => {
  const {
    heading,
    subheading,
    text,
    theme = '',
    program,
    productID,
    planLengths,
    plansPage,
    plans: _plans,
  } = props;
  const headerProps = { heading, theme, subheading };
  const colors = useColors();
  const fetch = useFetch();
  const [plans, setPlans] = useState<Plan[]>(_plans || []);

  useEffect(() => {
    if (program && !props.plans)
      getPlans({ program, productID, planLengths, fetch }).then((plans) =>
        setPlans(plans),
      );
  }, [program, planLengths, productID]);

  trackPlansView(plans);

  if (!program)
    return (
      // eslint-disable-next-line formatjs/no-literal-string-in-jsx
      <Box textAlign="center" p={5}>
        Select a program
      </Box>
    );

  return (
    <Box bg={colors[theme] || 'bg-0'} data-testid="plan-selector-block">
      <AdminWrapper>
        <Box
          px={4}
          py={5}
          sx={{
            borderTop: `1px solid ${colors.gray5}`,
            borderBottom: `1px solid ${colors.gray5}`,
          }}
        >
          {(heading || subheading) && (
            <Box marginBottom={4}>
              <Headers {...headerProps} />
            </Box>
          )}
          <PlansSelection
            plansPage={plansPage || mockPlansPage}
            plans={plans}
          />

          {!!text && <RichText html={text} theme={theme} alignment="center" />}
        </Box>
      </AdminWrapper>
    </Box>
  );
};

PlanSelector.schema = {
  name: 'plan-selector',
  label: 'Plan Selector',
  editableProps: sharedPlanSelectorFields.filter(
    (field) => field.name !== 'planVersion',
  ),
};

/**
 * Returns the program and planLengths arguments from a ComposerBlock.
 * @param {ComposerBlock} block - The ComposerBlock to extract arguments from.
 * @returns {Object} An object containing the program and planLengths arguments.
 */
PlanSelector.getPlansParams = (block: ComposerBlock) => {
  const { productID, planLengths = [6, 12, 24] } = block.args;

  return { productIDs: planLengths.map(() => productID) };
};

export default PlanSelector;
